import { useCallback, useState, type ReactNode } from 'react';
import { ToastContext, type ToastType } from './useToast';

interface Toast {
  id: number;
  type: ToastType;
  message: string;
}

const icons: Record<ToastType, { icon: string; cls: string }> = {
  success: { icon: 'ri-checkbox-circle-line', cls: 'text-emerald-600' },
  error: { icon: 'ri-error-warning-line', cls: 'text-red-600' },
  info: { icon: 'ri-information-line', cls: 'text-navy-600' },
};

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const push = useCallback((type: ToastType, message: string) => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, type, message }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 3500);
  }, []);

  return (
    <ToastContext.Provider value={{ push }}>
      {children}
      <div className="pointer-events-none fixed right-4 top-4 z-[100] flex w-full max-w-xs flex-col gap-2">
        {toasts.map((t) => (
          <div
            key={t.id}
            className="pointer-events-auto flex items-start gap-2.5 rounded-lg border border-navy-100 bg-white px-4 py-3 shadow-sm"
          >
            <i className={`${icons[t.type].icon} ${icons[t.type].cls} mt-0.5`} />
            <p className="text-sm text-navy-800">{t.message}</p>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}
